<template>
    <div id="listDunningNotice">
        <section class="content">
            <app-menu v-if="isLoggedIn"></app-menu>
            <template v-if="cantAccessPage === true">
                <div class="container-fluid">
                    <div class="block-header">
                        <h2>Over Due Customers</h2>
                        <!-- <button id="create"   v-on:click.prevent="addCustomer">+Add</button> -->
                        <div class="btn-group btn-group-lg" role="group" aria-label="Large button group">
                            <button type="button" class="btn bg-pink waves-effect" v-on:click="allClickDunning()">All </button>
                            <button type="button" class="btn bg-pink waves-effect" v-on:click="myClickDunning()">My Self</button>
                        </div>
                    </div>
                    <div class="body">
                        <div class="row clearfix">
                            <div class="col-sm-12">
                                <div class="clearfix">
                                    <div class="body col-lg-6 col-md-6 col-xs-12 col-sm-12">
                                        <label for="totalDue">Search For Collector</label>
                                        <div class="clearfix">
                                            <!--<select class="form-control show-tick" id="collectorFilter">
                                                <option value="">Please select</option>
                                                <template v-for="(collectorData , index) in collectorArr">
                                                    <option :value="collectorData.value">{{collectorData.text}}</option>
                                                </template>
                                            </select>-->
                                            <v-select
                                                name="collectorIdSearch"
                                                v-model="collectorIdSearch"
                                                @change="changedValue"
                                                id="collectorIdSearch" label="text"
                                                :options="collectorArr"
                                                :required="true"
                                                v-validate="'required'"
                                                ></v-select>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <br>
                                    <div class="body col-lg-4 col-md-4 col-xs-12 col-sm-12 clearfix">
                                        <label for="totalDue">Search For Past Due</label>
                                        <div class="clearfix">
                                            <select class="form-control show-tick" id="totlaDueCondition">
                                                <option value="">Please select</option>
                                                <option value="=">is</option>
                                                <option value=">">></option>
                                                <option value=">=">>=</option>
                                                <option value="<"><</option>
                                                <option value="<="><=</option>
                                                <option value="between">Between</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="body col-lg-4 col-md-4 col-xs-12 col-sm-12" v-show="totalDueCondition != ''">
                                        <label for="totalDue">Enter Value</label>
                                        <div class="clearfix">
                                            <input type="text" class="form-control" placeholder="Enter Data" id="totalDueAmt1"/>
                                        </div>
                                    </div>
                                    <div class="body col-lg-4 col-md-4 col-xs-12 col-sm-12" v-show="totalDueCondition == 'between'">
                                        <label for="totalDue">Enter Value</label>
                                        <div class="clearfix">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input type="text" class="form-control" placeholder="Enter Data" id="totalDueAmt2"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="body col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <br>
                                    <input id="addTaskBtn" type="button" value="Filter" class="btn general-button btn-success waves-effect pull-left" v-on:click="loadCustomers()">
                                    <input id="addTaskBtn" type="button" value="Reset" class="btn general-button btn-success waves-effect pull-left" v-on:click="reset()">
                                    <br><br>
                                </div>
                            </div>
                        </div>
                    </div>
                    <vue-good-table
                        ref="listDunningNotice"
                        mode="remote"
                        title="Over Due"
                        @on-page-change="onPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :selectOptions="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                        }"
                        :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: 25,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                        }"

                        :search-options="{
                        enabled: false,
                        }">
                        <div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <template v-if="permission.name == 'can_sends_dunning_notice_mails'" v-for="(permission, index) in permissions">
                                <!-- <button v-on:click.prevent="sendMailALL" class="btn general-button btn-success waves-effect" data-target="#queueEmail">ALL</button> -->
                                <button data-toggle="modal" title='Send mail to all' class="btn general-button btn-success waves-effect" data-target="#queueEmailAll" >Send Mail To All {{totalRecords}}</button>
                                <button data-toggle="modal" title='Send mail to selected' class="btn general-button btn-success waves-effect" data-target="#queueEmail" >Send Mail To Selected</button>
                                <!--                        <button v-on:click="sendMail($event)">Send Mail</button>-->
                            </template>    
                        </div>
                    </vue-good-table>
                </div>
                <div class="modal fade" id="queueEmailAll" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title" id="defaultModalLabel">Send Over Due To All</h4>
                            </div>
                            <form class="form-inline" id="importTasksform" enctype="multipart/form-data">
                                <div class="modal-body">
                                    <!--<div class="body col-xs-12 col-sm-6">-->
                                    <!--<label for="collector">Select Email Template</label>-->
                                    <!--<div class="clearfix">-->
                                    <!--<div>-->
                                    <!--<v-select-->
                                    <!--name="collectorId"-->
                                    <!--v-model="collectorId"-->
                                    <!--@change="changedValue"-->
                                    <!--id="collectorId" label="text"-->
                                    <!--:options="collectorArr"-->
                                    <!--:required="true"-->
                                    <!--v-validate="'required'"-->
                                    <!--&gt;</v-select>-->
                                    <!--<span v-show="errors.has('collectorId')" class="help is-danger" v-if="errors.has('collectorId')"><font color="red">Please Select Emial Template</font></span>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                    <!--<div class="demo-switch">-->
                                    <!--<div class="switch">-->
                                    <!--<label>Schedule <input type="checkbox" value="checked" v-model="checked"><span class="lever"></span></label>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                    <div class="clearfix">
                                        <label>Select Email Template</label>
                                        <select class="form-control show-tick" id="duningTemplateAll" name="duningTemplateAll">
                                            <option value="dunningNotice" select="selected">Default</option>
                                            <option value="dunning">Template 1</option>
                                        </select>
                                    </div>
                                    <!--<input type="text" id="scheduleDateAll" name="schedule_date"-->
                                    <!--class="datetimepicker form-control"-->
                                    <!--placeholder="Please choose date & time..." :disabled="!checked">-->
                                    <!--</div>-->
                                    <div class="modal-footer">
                                        <button type="button" id='btnsendmailall' v-on:click="sendMailALL($event)" class="btn general-button btn-success waves-effect">Send to All</button>
                                        <button type="button" class="btn general-button btn-danger waves-effect" data-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="queueEmail" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title" id="defaultModalLabel">Send Over Due To Selected</h4>
                            </div>
                            <form class="form-inline" id="importTasksform" enctype="multipart/form-data">
                                <div class="modal-body">
                                    <!--<div class="body col-xs-12 col-sm-6">-->
                                    <!--<label for="collector">Select Email Template</label>-->
                                    <!--<div class="clearfix">-->
                                    <!--<div>-->
                                    <!--<v-select-->
                                    <!--name="collectorId"-->
                                    <!--v-model="collectorId"-->
                                    <!--@change="changedValue"-->
                                    <!--id="collectorId" label="text"-->
                                    <!--:options="collectorArr"-->
                                    <!--:required="true"-->
                                    <!--v-validate="'required'"-->
                                    <!--&gt;</v-select>-->
                                    <!--<span v-show="errors.has('collectorId')" class="help is-danger" v-if="errors.has('collectorId')"><font color="red">Please Select Emial Template</font></span>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                    <!--<div class="demo-switch">-->
                                    <!--<div class="switch">-->
                                    <!--<label>Schedule <input type="checkbox" value="checked" v-model="checked"><span class="lever"></span></label>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                    <div class="clearfix">
                                        <label>Select Email Template</label>
                                        <select class="form-control show-tick" id="duningTemplateSelected" name="duningTemplateSelected" v-model="duningTemplateSelected">
                                            <option value="dunningNotice" select="selected">Default</option>
                                            <option value="dunning">Template 1</option>
                                        </select>
                                    </div>
                                    <!--<input type="text" id="scheduleDate" name="schedule_date"-->
                                    <!--class="datetimepicker form-control"-->
                                    <!--placeholder="Please choose date & time..." :disabled="!checked">-->
                                    <div class="modal-footer">
                                        <button type="button" id='btnsendmail' v-on:click="sendMail($event)" class="btn general-button btn-success waves-effect">Send to Selected</button>
                                        <button type="button" class="btn general-button btn-danger waves-effect" data-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="admin-page-content">
                    <div class="col-md-12 error-detail-main forms-container">
                        <div class="error-template">
                            <h1>Oops!</h1>
                            <h2>403</h2>
                            <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                        </div>
                    </div>
                </div>
            </template>
        </section>
    </div>
</template>

<script>

    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import FrontMenu from '@/components/partials/FrontMenu';
    Vue.use(VueGoodTable);
    import EventBus from '../event-bus';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');
    import SessioMixin from '../../mixins/sessionmixin';

    export default {
        name: "listDunningNotice",
        mixins: [SessioMixin],
        data: () => ({
                permissions: [],
                cantAccessPage: true,
                checked: false,
                flagAll: '',
                isLoggedIn: false,
                message: 'all',
                firstLoad: 0,
                totalDueCondition: '',
                searchFieldName: '',
                duningTemplateSelected: 'dunningNotice',
                duningTemplateAll: 'dunningNotice',
                columns: [
                    {
                        label: 'Collector',
                        field: 'user_first_name',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Collector", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'CusId',
                        field: 'cusid',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "CusId", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Customer Name',
                        field: 'first_name',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Customer Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /*{
                     label: 'Contact Name',
                     field: 'contact_name',
                     filterable: true,
                     filterOptions: {
                     enabled: false, // enable filter for this column
                     placeholder: "Name", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     filterDropdownItems: [], // dropdown (with selected values) instead of text input
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },
                     {
                     label: 'Contact Phone',
                     field: 'contact_phone',
                     filterable: true,
                     filterOptions: {
                     enabled: false, // enable filter for this column
                     placeholder: "Phone", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     filterDropdownItems: [], // dropdown (with selected values) instead of text input
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },
                     {
                     label: 'Contact Email',
                     field: 'contact_email',
                     filterable: true,
                     filterOptions: {
                     enabled: false, // enable filter for this column
                     placeholder: "Email", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     filterDropdownItems: [], // dropdown (with selected values) instead of text input
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },*/
                    {
                        label: 'Customer Type',
                        field: 'customer_type',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Customer Type", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /*{
                     label: 'Invoice Age',
                     field: 'invoice_age',
                     filterable: true,
                     filterOptions: {
                     enabled: false, // enable filter for this column
                     placeholder: "Invoice Age", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },
                     {
                     label: 'Invoice Date',
                     field: 'invoice_date',
                     filterable: true,
                     filterOptions: {
                     enabled: false, // enable filter for this column
                     placeholder: "MM-DD-YYYY", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },*/
                    {
                        label: 'Past Due',
                        field: 'due_days',
                        filterable: true,
                        type: 'number',
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Past Due", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /* {
                     label: 'Last Invoice Amount',
                     field: 'invoice_amount',
                     filterable: false,
                     type: 'number',
                     filterOptions: {
                     enabled: false, // enable filter for this column
                     placeholder: "Last Invoice Amount", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },
                     {
                     label: 'Last Paid Amount',
                     field: 'paid_amount',
                     filterable: false,
                     type: 'number',
                     filterOptions: {
                     enabled: false, // enable filter for this column
                     placeholder: "Last Paid Amount", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },*/
                    {
                        label: 'Current Due',
                        field: 'current_due',
                        filterable: true,
                        type: 'number',
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Current Due", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Over 01',
                        field: 'D1TO30D',
                        filterable: false,
                        type: 'number',
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Due 1 to 30", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Over 30',
                        field: 'D31TO60D',
                        filterable: false,
                        type: 'number',
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Due 31 to 60", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Over 60',
                        field: 'D61TO90D',
                        filterable: false,
                        type: 'number',
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "due 61 to 90", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Total Due',
                        field: 'total_due',
                        filterable: true,
                        type: 'number',
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Total Due", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                            /*{
                             label: 'Amount Balance',
                             field: 'amount_balance',
                             filterable: true,
                             type: 'number',
                             filterOptions: {
                             enabled: false, // enable filter for this column
                             placeholder: "Amount Balance", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             trigger: "enter" //only trigger on enter not on keyup
                             }
                             }, 
                             {
                             label: 'Created Date',
                             field: 'excede_created_at',
                             filterable: true,
                             filterOptions: {
                             enabled: false, // enable filter for this column
                             placeholder: "MM-DD-YYYY", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             trigger: "enter" //only trigger on enter not on keyup
                             }
                             },
                             {
                             label: 'Updated Date',
                             field: 'excede_updated_at',
                             filterable: true,
                             filterOptions: {
                             enabled: false, // enable filter for this column
                             placeholder: "MM-DD-YYYY", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             trigger: "enter", //only trigger on enter not on keyup
                             
                             }
                             },*/
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {

                    },
                    sort: {
                        field: 'id',
                        type: 'asc',
                    },
                    page: 1,
                    perPage: 25
                },
                selectedRows: 0,
                collectorArr: [],
                collectorId: "",
                collectorIdSearch: "",

            }),

        mounted: function () {
            var self = this;
            $(".removeActive").removeClass('active');
            $("#menudunningnotices").addClass('active');
            var self = this;
            $('.datetimepicker').bootstrapMaterialDatePicker({
                // format: 'dddd DD MMMM YYYY - HH:mm',
                format: 'MM/DD/YYYY HH:mm:ss',
                clearButton: true,
                weekStart: 1
            });
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            self.showLoader();
            $("#totlaDueCondition").change(function () {
                self.totalDueCondition = $("#totlaDueCondition").val();
            });
            self.loadCustomers();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
            self.loadCollector();
        },
        beforeMount: function () {

            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
                app.getPermissions();
            }
        },
        methods: {
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_see_dunning_notice_list') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },

            changedValue: function (value) {
                var self = this;
                console.log(value);
                self.loadCollector();
            },

            loadCollector() {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/getCollector",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    dataType: "json",
                    success: function (data) {
                        self.collectorArr = data.content;
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },

            sendMailALL: function (e)
            {
                var self = this;
                self.flagAll = 'flagAll_Dunning';
                var scheduleDate = '';
                if (this.checked) {
                    scheduleDate = $('#scheduleDateAll').val();
                }
                var duningTemplateAll = $('#duningTemplateAll').val();
                //change button
                $(e.target).text('Sending...');
                $(e.target).prop("disabled", true);

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    flag: "welcomeCustomers",
                    messageData: self.message,
                    sort: self.serverParams.sort,
                    totlaDueCondition: self.totalDueCondition,
                    searchFieldName: self.searchFieldName,
                    totalDue1: $('#totalDueAmt1').val(),
                    totalDue2: $('#totalDueAmt2').val(),
                    flagValue: self.flagAll,
                    scheduleDate: scheduleDate,
                    duningTemplateSelected: self.duningTemplateSelected,
                    duningTemplateAll: self.duningTemplateAll,
                };

                this.firstLoad = 1;
                // console.log(self.serverParams.perPage);
                $.ajax({
                    url: process.env.ROOT_API + "/list_dunningnotice",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.loadCustomers();
                        $(e.target).text('Send to All');
                        $(e.target).prop("disabled", false);
                        self.rows = data.content.row;
                        $('#scheduleDateAll').val('');
                        $('#queueEmailAll').modal('hide');
                        if (data.code == '200') {
                            // self.rows = data.content.row;
                            // self.totalRecords = data.content.totalRecords;
                            self.flagAll = '';

                            //alert("ALL Mail Scheduled Successfully.");
                            Swal.fire({
                                type: 'success',
                                title: 'Success',
                                html: 'ALL Mail Scheduled Successfully.',
                                showConfirmButton: true,
                            });
                        }
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        $('#scheduleDateAll').val('');
                        $('#queueEmailAll').modal('hide');
                        self.loadCustomers();
                        $(e.target).text('Send to All');
                        $(e.target).prop("disabled", false);
                        self.rows = data.content.row;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }
                });
            },

            sendMail: function (e) {

                var selectedCustomers = this.$refs['listDunningNotice'].selectedRows;
                var custArr = [];
                for (var i = 0; i < selectedCustomers.length; i++) {
                    custArr.push(this.$refs['listDunningNotice'].selectedRows[i].id);
                }
                var scheduleDate = '';
                if (this.checked) {
                    scheduleDate = $('#scheduleDate').val();
                }
                var duningTemplateSelected = $('#duningTemplateSelected').val();
                //console.log(duningTemplateSelected);
                //change button 
                $(e.target).text('Sending...');
                $(e.target).prop("disabled", true);
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/customer/send-dunning-notice",
                    type: "POST",
                    data: {customerArr: custArr, scheduleDate: scheduleDate, duningTemplateSelected: duningTemplateSelected},
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        //send mail button
                        $(e.target).text('Send to Selected');
                        $(e.target).prop("disabled", false);
                        self.loadCustomers();
                        self.checked = false;
                        $('#scheduleDate').val('');
                        $('#queueEmail').modal('hide');
                        if (data.code == '200') {
                            //alert("Mail Scheduled Successfully.");
                            Swal.fire({
                                type: 'success',
                                title: 'Success',
                                html: 'Mail Scheduled Successfully.',
                                showConfirmButton: true,
                            });
                        }
                    },
                    error: function (jqXHR, exception) {
                        $('#scheduleDate').val('');
                        $('#queueEmail').modal('hide');
                        $(e.target).text('Send to Selected');
                        $(e.target).prop("disabled", false);
                        self.loadCustomers();
                        self.checked = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            //
            onPageChange(params) {
                this.updateParams({page: params.currentPage});

                this.loadCustomers();
            },
            //
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadCustomers();
            },

            onColumnFilter(params)
            {
                this.updateParams(params);
                {
                    field: ('first_name');
                    field: ('description');
                    field: ('cusid');
                    field:('customer_type');
                    field:('created_at');
                    field: ('contact_name');
                    field: ('contact_phone');
                    field: ('email');
                    field:('collector');
                    field:('amount_balance');
                    field: ('total_due');
                    field: ('D61TO90D');
                    field: ('D31TO60D');
                    field:('D1TO30D');
                    field:('current_due');
                    field: ('paid_amount');
                    field: ('invoice_amount');
                    field:('cusid');
                    field:('invoice_date');
                }
                ;
                this.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;

                if (this.firstLoad == 1 || filters.first_name || filters.description || filters.cusid || filters.customer_type
                        || filters.created_at || filters.contact_name || filters.contact_phone || filters.email || filters.collector
                        || filters.amount_balance || filters.total_due || filters.D61TO90D || filters.D31TO60D || filters.D1TO30D
                        || filters.current_due || filters.paid_amount || filters.invoice_amount || filters.invoice_date
                        || filters.cusid) {
                    this.loadCustomers();
                }
            },
            selectionChanged() {
                var self = this;
                self.selectedRows = (self.$refs['listDunningNotice'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },
            allClickDunning: function () {
                var self = this;
                self.message = 'all';
                self.loadCustomers();
            },
            myClickDunning: function () {
                var self = this;
                self.message = 'my';
                self.loadCustomers();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        /* type: params.sortType,
                        field: this.columns[params.columnIndex].field, */
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadCustomers();
            },

            reset: function () {
                var self = this;
                self.totalDueCondition = '';
                $('#totlaDueCondition').val('');
                $('#totalDueAmt1').val('');
                $('#totalDueAmt2').val('');
                $("#collectorFilter").val('');
                self.collectorIdSearch = '';
                self.loadCustomers();
            },
            loadCustomers: function () {
                var self = this;
                var collectId = "";
                if (self.collectorIdSearch === null || self.collectorIdSearch == '') {
                    collectId = "";
                } else {
                    collectId = self.collectorIdSearch.value;
                }
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    flag: "dunning",
                    messageData: self.message,
                    sort: self.serverParams.sort,
                    totlaDueCondition: self.totalDueCondition,
                    totalDue1: $('#totalDueAmt1').val(),
                    totalDue2: $('#totalDueAmt2').val(),
                    /*collectorid: $("#collectorFilter").val(),*/
                    collectorid: collectId,
                };

                this.firstLoad = 1;
                // console.log(self.serverParams.perPage);
                $.ajax({
                    url: process.env.ROOT_API + "/list_dunningnotice",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.code == '200') {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }

                });
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }

        }
    };
</script>
<style>
    .vgt-checkbox-col input {
        opacity: 1 !important;
        position: static !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/dunningNotices/ListDunningNotice.vue